export default __webpack_public_path__ + "static/media/Quiken_Presencia_Nacional_Internacional.8add1249.png";